// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"43629":"b5f58125","66406":"56d9025d","91683":"c83a3e7d"}[chunkId] || chunkId) + ".218659fdfa2a5493.js";
};